import React from "react";
import { default as MuiBox } from "@mui/material/Box";
import { BoxProps as MuiBoxProps } from "@mui/material/Box";

export type BoxProps = MuiBoxProps;

export const Box = React.forwardRef<HTMLDivElement, BoxProps>(({ children, ...props }, ref) => (
  <MuiBox ref={ref} data-testid="box" {...props}>
    {children}
  </MuiBox>
));

Box.displayName = "Box";
